import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowLeft, Inbox, LogOut, CreditCard } from "lucide-react";
import { useAuth } from "../auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MonCompte() {
  const { user, logout } = useAuth();
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/my/quotes`, { withCredentials: true });
        setQuotes(data);
      } catch {
        setQuotes([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div data-testid="account-page" className="min-h-screen bg-[#050505] px-6 md:px-10 py-12">
      <div className="max-w-[1000px] mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <Link to="/" data-testid="account-back" className="inline-flex items-center gap-2 font-mono-accent text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-cyan transition-colors">
              <ArrowLeft size={14} /> Retour au site
            </Link>
            <h1 className="font-display font-700 uppercase tracking-tighter text-3xl md:text-5xl mt-4">
              Mon <span className="text-cyan">Compte</span>
            </h1>
            {user && <p className="text-neutral-400 font-light mt-2">{user.name || user.email}</p>}
          </div>
          <div className="flex items-center gap-3">
            {user?.role === "admin" && (
              <Link to="/admin" data-testid="account-admin-link" className="inline-flex items-center gap-2 border border-cyan-400/40 text-cyan rounded-full px-4 py-2 text-sm hover:bg-cyan-400 hover:text-black transition-colors">
                Tableau admin
              </Link>
            )}
            <button data-testid="account-logout" onClick={logout} className="inline-flex items-center gap-2 border border-white/10 rounded-full px-4 py-2 text-sm hover:border-red-400 hover:text-red-400 transition-colors">
              <LogOut size={15} /> Déconnexion
            </button>
          </div>
        </div>

        <h2 className="font-mono-accent text-xs uppercase tracking-[0.25em] text-cyan mb-5">Mes demandes de devis</h2>

        {loading ? (
          <p className="text-neutral-500 font-light">Chargement...</p>
        ) : quotes.length === 0 ? (
          <div className="flex flex-col items-center gap-4 py-20 text-neutral-500">
            <Inbox size={44} />
            <p className="font-light">Aucune demande pour le moment.</p>
            <Link to="/#devis" className="text-cyan font-mono-accent text-xs uppercase tracking-widest">Demander un devis</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {quotes.map((q) => (
              <div key={q.id} data-testid={`account-quote-${q.id}`} className="glass rounded-2xl border border-cyan-500/15 p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="font-display font-600 text-lg">{q.vehicle}</span>
                  <span className="font-mono-accent text-[10px] uppercase tracking-widest bg-cyan-400/15 text-cyan px-2.5 py-1 rounded-full">
                    {new Date(q.created_at).toLocaleDateString("fr-FR")}
                  </span>
                </div>
                <p className="text-cyan text-sm mb-2 flex items-center gap-2"><CreditCard size={14} /> {q.service}</p>
                {q.message ? <p className="text-neutral-400 text-sm font-light pt-2 border-t border-white/10 mt-2">{q.message}</p> : null}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
